<sc-flex vertical fitHeight stretchContent
  class="no-field-space add-article-type-selection-dialog">

  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="erp.ui.articletype-selection.title"></sc-dictionary-label>
  </sc-dialog-title>

  <sc-padding>
    <div class="types-grid">
      @for (articleType of articleTypeService.getNonArchived(); track articleType) {
        <sc-bordered-tile
          [style]="selected === articleType ? 'selected' : ''">
          <sc-padding (click)="selectArticleType(articleType)">
            <app-dictionary-entry-label [model]="articleType.name"></app-dictionary-entry-label>
          </sc-padding>
        </sc-bordered-tile>
      }
    </div>
  </sc-padding>

  <sc-actionbar>
    <sc-content-spacer grow></sc-content-spacer>
    <button mat-stroked-button (click)="onClose()">
      <sc-dictionary-label dictionaryKey="erp.ui.articletype-selection.action.cancel"></sc-dictionary-label>
    </button>
    <sc-content-spacer></sc-content-spacer>
    <button mat-flat-button (click)="onConfirm()" [disabled]="selected == null">
      <sc-dictionary-label dictionaryKey="erp.ui.articletype-selection.action.confirm"></sc-dictionary-label>
    </button>
  </sc-actionbar>
</sc-flex>
